import './theme_default.scss'
import ITheme from '../ITheme';

export default class ThemeDefault implements ITheme {
    id: string =  "default";
    cssClassName: string = "theme_default";    
    dark: boolean = false;
    menuDark: boolean = false;
    toolbarDark: boolean = true;
    menuRight: boolean = false;
    vuetifyTheme: any = {
        accent: '#81c784'
    }
}
